/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceXfoundportalobjekt as AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IAntwortDisplayModel {
  anfrageId?: null | string;
  antwortId?: null | string;
  datum?: null | string;
  dezimalzahl?: null | number;
  frageId: string;
  ganzezahl?: null | number;
  gutachtenId?: null | string;
  jaNein?: null | boolean;
  reihenfolgeAbschnitt?: null | number;
  reportId?: null | string;
  scope?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  text?: null | string;
  textEinzeilig?: null | string;
  waehrung?: null | number;
}
export class AntwortDisplayModel extends BaseModel implements IAntwortDisplayModel {
  anfrageId?: null | string;
  antwortId?: null | string;
  datum?: null | string;
  dezimalzahl?: null | number;
  frageId: string;
  ganzezahl?: null | number;
  gutachtenId?: null | string;
  jaNein?: null | boolean;
  reihenfolgeAbschnitt?: null | number;
  reportId?: null | string;
  scope?: AceXFoundPortalCoreEntitiesGlobalEnumsAceXfoundportalobjekt;
  text?: null | string;
  textEinzeilig?: null | string;
  waehrung?: null | number;
}
class BaseAntwortDisplayModelFormGroup extends FormGroup {
  private static _instance: AntwortDisplayModelFormGroup;
  
  public static get Instance(): AntwortDisplayModelFormGroup {
    this._instance = new AntwortDisplayModelFormGroup({
      anfrageId: new FormControl(null),
      antwortId: new FormControl(null),
      datum: new FormControl(null),
      dezimalzahl: new FormControl(null),
      frageId: new FormControl(null, [Validators.required]),
      ganzezahl: new FormControl(null),
      gutachtenId: new FormControl(null),
      jaNein: new FormControl(null),
      reihenfolgeAbschnitt: new FormControl(null),
      reportId: new FormControl(null),
      scope: new FormControl(null),
      text: new FormControl(null),
      textEinzeilig: new FormControl(null),
      waehrung: new FormControl(null),
    });

    return this._instance;
  }
}


export class AntwortDisplayModelFormGroup extends BaseAntwortDisplayModelFormGroup {
  public get AnfrageId(): FormControl {
    return this.controls["anfrageId"] as FormControl;
  }
  public get AntwortId(): FormControl {
    return this.controls["antwortId"] as FormControl;
  }
  public get Datum(): FormControl {
    return this.controls["datum"] as FormControl;
  }
  public get Dezimalzahl(): FormControl {
    return this.controls["dezimalzahl"] as FormControl;
  }
  public get FrageId(): FormControl {
    return this.controls["frageId"] as FormControl;
  }
  public get Ganzezahl(): FormControl {
    return this.controls["ganzezahl"] as FormControl;
  }
  public get GutachtenId(): FormControl {
    return this.controls["gutachtenId"] as FormControl;
  }
  public get JaNein(): FormControl {
    return this.controls["jaNein"] as FormControl;
  }
  public get ReihenfolgeAbschnitt(): FormControl {
    return this.controls["reihenfolgeAbschnitt"] as FormControl;
  }
  public get ReportId(): FormControl {
    return this.controls["reportId"] as FormControl;
  }
  public get Scope(): FormControl {
    return this.controls["scope"] as FormControl;
  }
  public get Text(): FormControl {
    return this.controls["text"] as FormControl;
  }
  public get TextEinzeilig(): FormControl {
    return this.controls["textEinzeilig"] as FormControl;
  }
  public get Waehrung(): FormControl {
    return this.controls["waehrung"] as FormControl;
  }
  

}

export module AntwortDisplayModelForm
  {
    export class FormFields
    {
      static _anfrageId: string = "anfrageId";
      static _antwortId: string = "antwortId";
      static _datum: string = "datum";
      static _dezimalzahl: string = "dezimalzahl";
      static _frageId: string = "frageId";
      static _ganzezahl: string = "ganzezahl";
      static _gutachtenId: string = "gutachtenId";
      static _jaNein: string = "jaNein";
      static _reihenfolgeAbschnitt: string = "reihenfolgeAbschnitt";
      static _reportId: string = "reportId";
      static _scope: string = "scope";
      static _text: string = "text";
      static _textEinzeilig: string = "textEinzeilig";
      static _waehrung: string = "waehrung";
    }
  }

